import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'saI18n',
  
})
export class SaI18nPipe implements PipeTransform {
  private constantArray: { [key: string]: string };

  constructor(private translate: TranslateService) {
    this.initConstantArray();
  }

  transform(label: string, args0?: any, args1?: any, args2?: any): any {
    const argsArray = [args0, args1, args2];
    let result = this.translate.instant(label);

    // replace the arguments {0}, {1}...
    for (let i = 0; i < argsArray.length; i++) {
      const repStr = '{{' + i + '}}';
      if (argsArray[i] !== undefined) {
        result = result.replace(repStr, argsArray[i].toString());
      } else {
        break;
      }
    }

    // replace the constants
    result = result.replace(/{{(.*?)}}/g, key => {
      if (this.constantArray[key]) {
        return this.constantArray[key];
      } else {
        return key;
      }
    });
    return result;
  }

  private initConstantArray = () => {
    this.constantArray = {};
    this.constantArray['{{productName}}'] = 'SOTI XSight';
    this.constantArray['{{nestProductName}}'] = 'MobiControl';
    this.constantArray['{nestProductNameCap}}'] = 'MOBICONTROL';
    this.constantArray['{{nestProductNameAbb}}'] = 'MC';
    this.constantArray['{{companyName}}'] = 'SOTI';
    this.constantArray['{{SMTP}}'] = 'SMTP';
    this.constantArray['{{SSL}}'] = 'SSL';
    this.constantArray['{{MAC}}'] = 'MAC';
    this.constantArray['{{IMEI}}'] = 'IMEI';
  };
}
